// extracted by mini-css-extract-plugin
export default {"wrapper":"FormDescription_wrapper__8VGCe","title":"FormDescription_title__FvgQ3","description":"FormDescription_description__Rdgs6"};